import { $api } from "@/shared/api";

// Один платёж игрока (`GET /api/billing/payments/{payment_id}`): статус и ссылка на страницу
// оплаты.
export const paymentQueryOptions = (paymentId: string) =>
  $api.queryOptions("get", "/api/billing/payments/{payment_id}", {
    params: { path: { payment_id: paymentId } },
  });

// Префикс ключей всех платежей — для инвалидации по событию `billing.updated`.
export const PAYMENT_QUERY_KEY_PREFIX = ["get", "/api/billing/payments/{payment_id}"] as const;
